import camelCase from 'lodash.camelcase';
import { CollectionPoint } from '../../../../types/collectionPoints';

const getCollectionPointI18nKey = (location: CollectionPoint) =>
  camelCase(
    location.deliveryOption.collectionPointType === 'post_office'
      ? `${location.deliveryOption.carrierGroupKey}_postoffice`
      : location.deliveryOption.collectionPointType === 'parcel_shop'
      ? `${location.deliveryOption.carrierGroupKey}_parcelshop`
      : location.deliveryOption
          .collectionPointType!.replace('reba', location.deliveryOption.carrierGroupKey)
          .replace('UB_', '')
          .replace('parcel_shop', 'parcelshop')
          .replace('servicepoint', 'parcelshop')
          .replace('post_office', 'postoffice')
          .replace('parcelbox', 'packstation')
  );

export default getCollectionPointI18nKey;
